export default __webpack_public_path__ + "51b621063d6f1363ea7f142fe3cfa24d.png";